module.exports = __webpack_public_path__ + "assets/fonts/bin.eafeb74d.svg";